import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
let mu = (flag || window.innerWidth < 900) ? 'm' : 'pc';
export default new Router({
  routes: [
    {
      path: '/',
      name: 'recruit',
      component: () => import('@/pages/' + mu + '/recruit')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js